.link {
  text-decoration: none;
  display: block;
  height: 100%;
}

.card {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.meta {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
  margin-bottom: var(--space-sm);
}

.date {
  font-family: var(--font-code);
  font-size: var(--text-xs);
  color: var(--text-muted);
}

.title {
  font-family: var(--font-heading);
  font-size: var(--text-lg);
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: var(--space-sm);
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.summary {
  font-size: var(--text-sm);
  color: var(--text-secondary);
  line-height: 1.6;
  margin-bottom: var(--space-md);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.tags {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-xs);
  margin-top: auto;
}

.arrow {
  position: absolute;
  top: var(--space-md);
  right: var(--space-md);
  color: var(--accent-cyan);
  font-size: var(--text-lg);
  opacity: 0;
  transform: translateX(-10px);
  transition: all var(--transition-fast);
}

.card:hover .arrow {
  opacity: 1;
  transform: translateX(0);
}
